













































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'
import LocalStore from '@/helpers/localstore'

/* Data types */
import {
  IItemForSelection,
  IPersonBase,
  IWorkflowForSelection,
} from '@/api/types/response.types'
import { IInternalProjectsInputCreate } from '@/api/types/request.types'
import { EEntities } from '@/types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import Avatar from '@/components/global/avatar.vue'

export default Vue.extend({
  metaInfo: {
    title: 'New Project',
  },

  components: {
    CardCanvas,
    Avatar,
  },

  data() {
    return {
      EEntities,
      RouteAssistant,
      ColorAssistant,
      focusName: true,
      isLoading: true,
      isSubmitting: false,
      workflows: [] as IWorkflowForSelection[],
      showCreateWorkflowDrawer: false,
      newProjectID: 0,
      assignedPeople: [] as IPersonBase[],
      defaultSelectedWorkflowID: null,

      // Input values
      name: '',
      selectedWorkflowID: null,
      enableJobs: this.$permissions.jobsFeatureEnabled,
    }
  },

  computed: {
    projectCreated(): boolean {
      return this.newProjectID !== 0
    },
    selectedWorkflow(): IWorkflowForSelection {
      if (!this.selectedWorkflowID) {
        return null
      }
      return this.workflows.find(w => w.id === this.selectedWorkflowID)
    },
    selectedWorkflowHasJobs(): boolean {
      if (!this.selectedWorkflow) {
        return false
      }
      return this.selectedWorkflow.listJobs.length > 0
    },
  },

  async created() {
    this.isLoading = true
    await this.getWorkflows()
    this.isLoading = false
    await this.$nextTick()
    this.selectedWorkflowID = this.workflows[0].id

    if (
      this.$route.query.workflow_id &&
      this.workflows.some(
        w => w.id.toString() === this.$route.query.workflow_id.toString(),
      )
    ) {
      this.defaultSelectedWorkflowID = this.$route.query.workflow_id
    }

    this.$nextTick(() => {
      // @ts-ignore
      this.$refs.nameRef.focus()
    })
  },

  methods: {
    goToProjectLanding() {
      LocalStore.setShowInfoOnEntityLanding(this.newProjectID)
      RouteAssistant.goToProjectLanding(
        this.$router,
        this.$route.params.accountId,
        this.newProjectID,
        this.$permissions,
      )
    },
    async handleWorkflowCreation(id: number) {
      await this.getWorkflows()

      const selectedWorkflow = this.workflows.find(w => w.id === id)
      const selectedIndex = this.workflows.findIndex(w => w.id === id)

      this.workflows.splice(selectedIndex, 1)
      this.workflows.unshift(selectedWorkflow)

      this.selectedWorkflowID = id
    },
    async getWorkflows() {
      this.workflows = await InternalProjectsAPI.get_Workflows()
    },
    async create() {
      if (this.name.trim().length === 0) {
        this.focusName = false
        await this.$nextTick()
        this.focusName = true
        this.$messaging.showError('Please enter a name.')
        return
      }
      this.isSubmitting = true
      try {
        const data = {
          name: this.name,
          workflowID: this.selectedWorkflowID,
          enableJobs: this.enableJobs,
        } as IInternalProjectsInputCreate
        const response = await InternalProjectsAPI.post_Create(data)
        this.newProjectID = response.id
      } catch (err) {
        this.$error.emit(err, true)
      } finally {
        this.isSubmitting = false
      }
    },
  },
})
